import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import Wrapper from './style';
import { getCookie } from '../../common/utils';
import { postContact } from '../../common/fetch';


class ContactUs extends Component {
	state = {
		loading: false
	};

	handleSubmit = (e) => {
		this.setState(
			{
				loading: true
			},
			async () => {
				const { handleOk, handleError } = this.props;
				const { getFieldValue } = this.props.form;
				e.preventDefault();

				const data = {
					email: getCookie('email'),
					category: getFieldValue('action'),
					subject: getFieldValue('action'),
					description: getFieldValue('message')
				};
				try {
					await postContact(data);
					return handleOk('Success');
				} catch (error) {
					return handleError('Fail to message');
				}
			}
		);
	};

	render() {
		const { visible, handleCancel } = this.props;
		// const { loading } = this.state;

		return (
			<Form onSubmit={this.handleSubmit}>
				<Modal
					visible={visible}
					onOk={this.handleSubmit}
					onCancel={handleCancel}
					title="Contact Us"
					footer={false}
				// footer={[
				// 	<Button key="back" onClick={handleCancel} disabled={loading}>
				// 		Return
				// 	</Button>,
				// 	<Button
				// 		key="submit"
				// 		type="primary"
				// 		onClick={this.handleSubmit}
				// 		disabled={loading}
				// 	>
				// 		Submit
				// 	</Button>
				// ]}
				>
					<Wrapper>
							<div className="contact-type">
								<p style={{ margin: '0px' }}>For cloud or paid on-premise exchanges contact :</p>
								<a href="mailto:support@hollaex.com">support@hollaex.com</a>
								<p style={{ marginTop: '5%', marginBottom:'0px' }}>For on-premise Basic free exchanges post questions publicly :</p>
								<a href="https://forum.hollaex.com">Forum.</a>
							</div>
					</Wrapper>
				</Modal>
			</Form>
		);
	}
}

export default Form.create({
	name: 'ContactUs'
})(ContactUs);
